import React from "react";
import PurpleStrategyPanel from "./panels/PurpleStrategyPanel";
import LoadingPanel from './panels/LoadingPanel';
import ErrorPanel from './panels/ErrorPanel';
import Seo from "../components/Seo";

class PurpleStrategy extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                error: null,
                isload:false,
                items:[]
            }
        }
    }

    componentDidMount() {
        console.log("componentDidMount");
        fetch("/json/purple_strategy.json")
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        items: result
                    });
                },
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    renderPanel() {
        const { error, isLoaded, items } = this.state;
        if (error) {
            console.log("error");
            return (
                <ErrorPanel data={error.message}/>
            );
        } else if (!isLoaded) {
            console.log("loading");
            return (
                <LoadingPanel />
            );
        } else {
            console.log("normal start");
            return (
                <PurpleStrategyPanel data={items} />
            );
        }
    }


    render() {
        return (
            <div>
                <Seo
                    title="Joyride 紫色策略"
                    description="Joyrdie 紫色策略, 摸底型策略."
                    url="https://joyride.tw/purple-strategy"
                    />
                {this.renderPanel()}
            </div>
        );
    }
}

export default PurpleStrategy